var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 391.123,
    height: 400
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1131",
    transform: "translate(-441.473 -370.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M655.09 410.597a.912.912 0 01-.351-1.754c2.3-.958 4.659-1.893 7.008-2.777a.912.912 0 11.643 1.707c-2.329.878-4.667 1.8-6.95 2.754a.9.9 0 01-.35.071m-13.647 6.253a.912.912 0 01-.41-1.728 211.503 211.503 0 016.8-3.261.912.912 0 11.76 1.659 211.926 211.926 0 00-6.739 3.233.9.9 0 01-.408.1m-13.171 7.209a.912.912 0 01-.467-1.7 209.285 209.285 0 016.546-3.741.912.912 0 01.877 1.6 208.502 208.502 0 00-6.489 3.708.909.909 0 01-.466.128m-12.607 8.156a.912.912 0 01-.524-1.66 206.583 206.583 0 016.258-4.21.913.913 0 11.991 1.533 201.577 201.577 0 00-6.2 4.172.91.91 0 01-.522.165m-11.977 9.057a.912.912 0 01-.577-1.619 204.965 204.965 0 015.929-4.661.912.912 0 111.1 1.455c-1.983 1.5-3.96 3.055-5.877 4.619a.911.911 0 01-.576.206m-11.269 9.924a.912.912 0 01-.628-1.575 202.091 202.091 0 015.567-5.091.915.915 0 011.211 1.371 198.43 198.43 0 00-5.517 5.044.911.911 0 01-.628.251m-10.495 10.746a.912.912 0 01-.676-1.524 207.17 207.17 0 015.167-5.5.912.912 0 111.305 1.275 194.546 194.546 0 00-5.119 5.447.91.91 0 01-.676.3m-9.627 11.527a.913.913 0 01-.722-1.469 187.725 187.725 0 014.722-5.888.912.912 0 011.4 1.169 186.981 186.981 0 00-4.676 5.831.911.911 0 01-.724.356m-8.634 12.296a.913.913 0 01-.77-1.4 165.908 165.908 0 014.2-6.279.912.912 0 111.492 1.049 159.584 159.584 0 00-4.155 6.208.911.911 0 01-.771.423",
    fill: "#a7deff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M710.968 421.403a.911.911 0 01-.727-.361 90.706 90.706 0 00-4.025-4.939.912.912 0 111.371-1.2c1.408 1.6 2.791 3.3 4.107 5.04a.912.912 0 01-.726 1.463m7.037 10.768a.911.911 0 01-.8-.467 93 93 0 00-3.3-5.452.913.913 0 011.528-1 93.828 93.828 0 013.365 5.56.912.912 0 01-.8 1.357m5.476 11.639a.911.911 0 01-.85-.583 92.024 92.024 0 00-2.509-5.856.912.912 0 011.651-.777 93.51 93.51 0 012.559 5.974.912.912 0 01-.521 1.18.9.9 0 01-.33.062m3.775 12.293a.913.913 0 01-.888-.708 88.909 88.909 0 00-1.652-6.151.912.912 0 011.744-.536 93.02 93.02 0 011.686 6.277.914.914 0 01-.89 1.117M566.686 428.57a.912.912 0 01-.684-1.515c1.453-1.65 2.99-3.288 4.568-4.869a.912.912 0 111.29 1.289 105.886 105.886 0 00-4.489 4.785.911.911 0 01-.685.31m-8.08 10.478a.912.912 0 01-.758-1.42 101.904 101.904 0 013.9-5.422.912.912 0 011.444 1.115 97.542 97.542 0 00-3.831 5.322.909.909 0 01-.758.4m-6.583 11.476a.913.913 0 01-.821-1.31 95.003 95.003 0 013.124-5.909.912.912 0 011.582.909 92.221 92.221 0 00-3.063 5.8.912.912 0 01-.822.515m-4.892 12.29a.914.914 0 01-.87-1.187 91.499 91.499 0 012.245-6.3.912.912 0 011.695.675 89.4 89.4 0 00-2.2 6.173.914.914 0 01-.87.639m-3 12.887a.939.939 0 01-.136-.01.912.912 0 01-.767-1.037c.325-2.164.75-4.376 1.263-6.575a.912.912 0 011.777.415 83.237 83.237 0 00-1.236 6.43.913.913 0 01-.9.777M624.297 407.828a.916.916 0 01-.26-.038 110.866 110.866 0 00-6.741-1.765.912.912 0 01.401-1.779c2.293.524 4.6 1.127 6.853 1.795a.913.913 0 01-.258 1.787m13.192 4.823a.907.907 0 01-.365-.077c-2.129-.932-4.306-1.8-6.47-2.6a.912.912 0 01.627-1.713c2.2.8 4.411 1.692 6.575 2.639a.913.913 0 01-.367 1.748m12.511 6.4a.907.907 0 01-.462-.126 119.566 119.566 0 00-6.114-3.361.912.912 0 01.831-1.624 121.581 121.581 0 016.207 3.412.913.913 0 01-.463 1.7m11.7 7.8a.906.906 0 01-.546-.182 131.04 131.04 0 00-5.7-4.031.912.912 0 111.012-1.517 132.927 132.927 0 015.781 4.088.912.912 0 01-.547 1.643m10.817 8.985a.907.907 0 01-.616-.24 144.745 144.745 0 00-5.263-4.6.912.912 0 011.166-1.4 146.475 146.475 0 015.33 4.658.912.912 0 01-.617 1.584m9.919 9.974a.909.909 0 01-.675-.3 161.968 161.968 0 00-4.819-5.069.913.913 0 111.295-1.286 163.438 163.438 0 014.874 5.128.912.912 0 01-.674 1.526m9.034 10.787a.911.911 0 01-.722-.355 173.257 173.257 0 00-4.385-5.457.913.913 0 111.4-1.171c1.49 1.78 2.98 3.635 4.43 5.513a.913.913 0 01-.722 1.47m8.175 11.455a.911.911 0 01-.762-.41 189.228 189.228 0 00-3.963-5.776.912.912 0 011.486-1.059c1.354 1.9 2.7 3.86 4 5.831a.912.912 0 01-.761 1.415m7.334 12.014a.911.911 0 01-.795-.464 204.388 204.388 0 00-3.546-6.044.912.912 0 111.557-.951c1.218 2 2.422 4.047 3.578 6.1a.912.912 0 01-.794 1.36m6.476 12.5a.912.912 0 01-.826-.522 192.205 192.205 0 00-3.111-6.28.912.912 0 011.62-.84 194.89 194.89 0 013.141 6.34.913.913 0 01-.824 1.3M650.194 471.745a.97.97 0 01-.125-.009 71.416 71.416 0 00-7.118-.616.912.912 0 01.065-1.823 73.06 73.06 0 017.3.632.912.912 0 01-.123 1.816m-21.636.306a.912.912 0 01-.147-1.813c2.416-.4 4.865-.677 7.278-.834a.912.912 0 11.118 1.82 73.103 73.103 0 00-7.1.814.953.953 0 01-.149.012m35.7 3.042a.911.911 0 01-.293-.049 76.895 76.895 0 00-6.87-1.987.912.912 0 11.424-1.775 78.665 78.665 0 017.032 2.034.913.913 0 01-.294 1.776m-49.687.614a.912.912 0 01-.308-1.771 84.054 84.054 0 016.989-2.17.912.912 0 01.463 1.765c-2.272.6-4.573 1.31-6.837 2.122a.91.91 0 01-.308.054m62.929 5.194a.9.9 0 01-.431-.109 92.803 92.803 0 00-6.436-3.148.912.912 0 11.735-1.67c2.187.963 4.4 2.043 6.565 3.212a.912.912 0 01-.433 1.716m-76.113.767a.912.912 0 01-.438-1.713 96.908 96.908 0 016.537-3.269.912.912 0 01.753 1.661 95.907 95.907 0 00-6.415 3.209.907.907 0 01-.437.112m88.333 6.975a.909.909 0 01-.538-.176 110.448 110.448 0 00-5.929-4.047.912.912 0 01.979-1.54 113.318 113.318 0 016.026 4.114.912.912 0 01-.539 1.649m-100.522.832a.912.912 0 01-.541-1.646c1.975-1.456 4-2.849 6.014-4.141a.912.912 0 01.985 1.536 111.23 111.23 0 00-5.918 4.074.909.909 0 01-.541.178m111.7 8.357a.908.908 0 01-.616-.239 139.101 139.101 0 00-5.427-4.717.912.912 0 111.159-1.408 141.95 141.95 0 015.5 4.779.912.912 0 01-.616 1.585m-122.815.933a.912.912 0 01-.627-1.575 120.007 120.007 0 015.455-4.852.912.912 0 111.17 1.4 117.942 117.942 0 00-5.371 4.778.91.91 0 01-.627.249",
    fill: "#a7deff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M718.259 516.337a.907.907 0 01-.706-.334q-1.165-1.422-2.326-2.791a.912.912 0 011.391-1.181q1.172 1.382 2.346 2.816a.912.912 0 01-.7 1.49",
    fill: "#b3e0d0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M612.793 397.91a26.193 26.193 0 10-26.194 26.193 26.194 26.194 0 0026.194-26.193",
    fill: "#fffffe",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M586.599 372.933a24.977 24.977 0 1024.977 24.977 25.006 25.006 0 00-24.977-24.977m0 52.387a27.41 27.41 0 1127.409-27.41 27.441 27.441 0 01-27.409 27.409",
    fill: "#61c8fa",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M718.227 397.91a26.193 26.193 0 10-26.194 26.193 26.194 26.194 0 0026.194-26.193",
    fill: "#fffffe",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1128",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1127"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M670.604 467.397a26.193 26.193 0 10-26.194 26.194 26.194 26.194 0 0026.194-26.194",
    fill: "#fffffe"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M644.409 442.434a24.977 24.977 0 1024.977 24.977 25.006 25.006 0 00-24.977-24.977m0 52.387a27.41 27.41 0 1127.41-27.409 27.44 27.44 0 01-27.41 27.409",
    fill: "#3ba799"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1126"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M631.215 481.201H658.2v-26.985h-26.985z",
    fill: "#fffffe"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M632.432 479.985h24.552v-24.552h-24.552zm-2.433 2.433h29.418V453h-29.418z",
    fill: "#3ba799"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M640.723 481.072l11.92-11.349 5.066 5.739.491 5.738-17.477-.129",
    fill: "#3ba799"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M641.45 467.708l-8.977 12.343h18.31l-9.333-12.343M650.783 461.902a2.188 2.188 0 10-2.188 2.188 2.188 2.188 0 002.188-2.188",
    fill: "#3ba799"
  }))), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M499.898 719.694h14V543.645h-14zM722.755 719.694h14V543.645h-14z",
    fill: "#19243c"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M467.479 626.447h319.337v-25.061H467.479zM467.479 586.325h319.337v-25.061H467.479z",
    fill: "#1a72f1"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M445 660.079l22.26-15.652h323.22l21.7 15.652c-110.688 3.748-234.992 3.136-367.182 0",
    fill: "#a7deff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M445 671.642h364.3v-11.563H445z",
    fill: "#1a72f1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M598.6 387.6H585a2.865 2.865 0 01-2.2-.8l-.9-.7a3.852 3.852 0 00-3-1.1h-4c-2.5 0-3.9 1.4-3.9 4.3v17.3c0 2.9 1.5 4.4 4.4 4.4H599c2.5 0 4-1.5 4-4.4V392c0-2.9-1.5-4.4-4.4-4.4z",
    fill: "#61c8fa"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1130",
    fill: "#1a72f1"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M692.032 372.933a24.977 24.977 0 1024.978 24.977 25.006 25.006 0 00-24.978-24.977m0 52.387a27.41 27.41 0 1127.41-27.41 27.44 27.44 0 01-27.41 27.409",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1129"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 722",
    width: 14.222,
    height: 3.556,
    rx: 1.778,
    transform: "translate(684.924 396.132)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Subtraction 1083",
    d: "M699 407h-3.406v-3H699a6 6 0 006-6 6.007 6.007 0 00-6-6h-3.406v-3H699a9.011 9.011 0 019 9 9.008 9.008 0 01-9 9zm-10.52 0H685a9.008 9.008 0 01-9-9 9.011 9.011 0 019-9h3.479v3H685a6.007 6.007 0 00-6 6 6 6 0 006 6h3.479v3z"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1172",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(694 389)"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1173",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(687 389)"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1174",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(694 404)"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1175",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(687 404)"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 1171",
    cx: 79.925,
    cy: 8.833,
    rx: 79.925,
    ry: 8.833,
    transform: "translate(459.943 752.833)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M520.43 753.271l8.435 7.233-2.172 10 10.386-13.263-13.923-12.182-2.726 8.21M549.42 740.104l-6.294 21.06 16.42 3.558-8.21-7.936 8.21-15.051-10.125-1.632",
    fill: "#0657cd"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M485.657 628.951s-58.1 34.883-41.052 60.567c0 0 19.159 24.325 75.513 64.462l6.574-7.3-51.525-63.65 34.189-22.652a48 48 0 0133.614-7.458l27.826 4.163-23.515 86.761 12.163 2.838s53.111-89.6 41.759-107.032-36.184-19.965-36.184-19.965l-79.362 9.266",
    fill: "#ff7381"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M583.263 530.288c-5.31-21.241-15.525-32.031-25.017-37.495a22.8 22.8 0 01-5.086 9.52c-10.947 12.772-28.582 18.853-43.177 9.123-5.9-4.294-9.439-10.484-12.278-16.9-8.32 4.742-17.192 12.177-22.082 23.587a106.08 106.08 0 00-5.5 18.873l13.451 14.6-1.849 79.864c29.324 5.958 59.833 1.3 91.626-8.086l-2.553-68.76 12.467-24.325",
    fill: "#0657cd"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M540.085 576.811l-5.017-3.5h-4.713v5.929l5.349 5.782 4.381-8.215",
    fill: "#fd9f9d"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M530.203 556.61h-14.59a1.525 1.525 0 00-1.52 1.52v26.89a1.525 1.525 0 001.52 1.52h14.59a1.525 1.525 0 001.52-1.52v-26.89a1.525 1.525 0 00-1.52-1.52",
    fill: "#131412"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M509.982 511.436c14.6 9.73 32.231 3.649 43.178-9.122a22.8 22.8 0 005.086-9.52 41.96 41.96 0 00-7.839-3.5c-3.919 12.081-15.145 21.017-29.478 19.713-9.228-1.086-14.093-9.439-16.762-17.707a70.223 70.223 0 00-6.463 3.244c2.839 6.412 6.374 12.6 12.278 16.9",
    fill: "#fffffe"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M520.929 509.001c14.333 1.3 25.559-7.633 29.478-19.713a40.63 40.63 0 00-9.838-1.952 5.991 5.991 0 01-5.146-3.724l-2.371-5.841-15.592 9.173a66.368 66.368 0 00-13.293 4.357c2.669 8.268 7.534 16.622 16.762 17.707",
    fill: "#fd9f9d"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M516.824 465.826s-7.45 1.064-4.865 8.97 6.818 18.718 9.706 18.566 4.433-.778 7.473-1.995c.435-.174.851-.345 1.245-.51a5.11 5.11 0 003-5.842l-1.209-5.354s6.233-3.8 4.409-6.538-6.078 2.433-6.078 2.433l-.912-11.2-12.769 1.47",
    fill: "#fd9f9d"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M530.507 475.556s-3.5-6.842-3.649-10.794c0 0-14.139 5.777-17.636.456s-.3-11.4 3.345-12.011 7.6 5.017 7.6 5.017 10.034-3.649 11.859 3.953 1.368 10.946 1.368 10.946l-2.889 2.433",
    fill: "#19243c"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M517.46 477.774a1.154 1.154 0 10-1.154 1.154 1.154 1.154 0 001.154-1.154M526.387 475.556a1.109 1.109 0 10-1.109 1.109 1.11 1.11 0 001.109-1.109",
    fill: "#131412"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M531.727 477.456a.3.3 0 01-.226-.507 14.318 14.318 0 013.511-2.861.304.304 0 11.305.526 13.727 13.727 0 00-3.364 2.74.3.3 0 01-.227.1M522.815 487.614h-.03a.304.304 0 010-.608h.024c.752 0 2.748-.289 3.294-1.631a.304.304 0 11.563.229c-.647 1.593-2.785 2.01-3.853 2.01M520.58 484.982s-2.591-7.863-.767-8.362 4.355 7.316 4.355 7.316l-3.589 1.045",
    fill: "#ff7381"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M513.731 475.222a.451.451 0 01-.224-.059.456.456 0 01-.173-.622 2.84 2.84 0 013.5-1.187.456.456 0 11-.356.839 1.932 1.932 0 00-2.347.8.456.456 0 01-.4.232M522.616 473.131a.451.451 0 01-.2-.046.457.457 0 01-.211-.609 2.772 2.772 0 013.462-1.287.456.456 0 01-.361.838 1.849 1.849 0 00-2.28.848.458.458 0 01-.411.257",
    fill: "#131412"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M583.264 530.289l-18.244 6.081c.191 2.1.4 4.588.622 7.339 6.487-1.983 12.987-3.8 19.534-5.245q-.9-4.126-1.911-8.176",
    fill: "#fffffe"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M565.641 543.709c1.542 19.181 3.635 51.042 3.635 51.042l-29.191-17.94-4.382 8.215s21.409 29.49 39.654 39.524c18.454 10.15 19.521-41.656 9.817-86.085-6.546 1.449-13.047 3.261-19.533 5.245",
    fill: "#fd9f9d"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M569.276 594.756l8.666 5.017-9.031-10.5.365 5.479",
    fill: "#ff7381"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M488.697 539.715l-18.576-2.716c-.468 2.2-.913 4.5-1.337 6.847 6.441.509 13.055 1.537 19.6 2.369l.31-6.5",
    fill: "#fffffe"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M507.713 579.548l-24.792 26.606 5.468-59.939c-6.548-.831-13.163-1.86-19.6-2.369-5.774 32.006-7.479 75.86-3.8 83.441 4.865 10.034 17.4 8.657 24.358-1.753s22.076-38.08 22.076-38.08l-3.7-7.906",
    fill: "#fd9f9d"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M482.921 606.153l-7.759 7.754 8.406-14.909-.653 7.155",
    fill: "#ff7381"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M507.713 579.548l3.7-3.041h13.315v5.644l-11.25 2.566-2.065 2.737-3.7-7.906",
    fill: "#fd9f9d"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M519.407 560.119a1.594 1.594 0 10-1.594 1.594 1.594 1.594 0 001.594-1.594",
    fill: "#fffffe"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M475.167 683.03l-7.754-8.92 11.957 5.988-4.2 2.932M570.796 657.082l2.63-10.338-9.246 9.348 6.616.99",
    fill: "#ff516c"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M521.825 494.261c-2.622 0-5.157-6.421-5.456-7.2l.568-.217c.811 2.12 3.333 7.464 5.24 6.747 2.58-.971 6.816-2.489 6.858-2.5l.206.572c-.043.015-4.273 1.531-6.849 2.5a1.6 1.6 0 01-.566.1",
    fill: "#ff7381"
  })), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 1176",
    cx: 64.925,
    cy: 7.333,
    rx: 64.925,
    ry: 7.333,
    transform: "translate(687.947 727.955)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M762.112 526.449c-4.917 2.116-9.817 4.243-14.737 6.323l.6 5.742c4.917-1.859 9.846-3.924 14.826-5.882q-.257-3.291-.693-6.183",
    fill: "#fffffe"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M780.959 555.502l-19.852 11.716c2.041-14.271 2.4-25.587 1.7-34.585-4.979 1.958-9.908 4.022-14.826 5.882l5.336 50.739c14.25 6.081 33.826-33.143 33.826-33.143l-6.181-.608",
    fill: "#ffaaa0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M763.391 725.751l13.094 10.79-3.652-10.79s6.278-6.764 14.628-16.482c-3.752-2.239-7.36-4.731-10.924-7.349l-13.149 23.83",
    fill: "#fff03d"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M788.647 620.69l-20.068 20.214 34.664 12.623-26.7 48.394c3.564 2.617 7.172 5.11 10.924 7.349 10.928-12.716 33.919-36.267 42.537-50.573 15.2-25.24-41.353-38.006-41.353-38.006",
    fill: "#ffaaa0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M746.301 708.881l-17.325 16.87 12.755 16.87-2.554-13.379s6.738-4.11 16.208-10.475a105.245 105.245 0 01-9.084-9.887",
    fill: "#fff03d"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M820.878 649.577c-9.2-18.894-40.745-19.46-40.745-19.46l-18.548 26.758 34.966 1.822-50.251 50.185a105.255 105.255 0 009.084 9.887c24.117-16.209 72.6-54.6 65.494-69.191",
    fill: "#fd9f9d"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M691.214 620.69s9.253 40.441 70.371 36.184l31.927-36.184a234.559 234.559 0 00-38.128-9.426l-64.17 9.426",
    fill: "#00cd74"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M747.895 500.002c-1.249 2.47-27.4 6.774-34.4-.522-38.132 16.757-22.281 121.208-22.281 121.208l66.2-9.318s.907-90.935-9.522-111.37",
    fill: "#fff03d"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M745.977 498.226l-2.351-1.1-25.539-.157a22.855 22.855 0 00-4.6 2.511c12.5 15.467 32.054 7.675 32.49-1.254",
    fill: "#fffffe"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M737.696 494.525l.3-8.629 3.565-7.394s-1.3-13.614-1.423-13.372-8.192-6.752-8.192-6.752a16.664 16.664 0 00-6.764 9.845 6.581 6.581 0 01-3.08 4.407 2.285 2.285 0 001.132 2.2s-.282.823-.584 1.931l3.712 1.2s-1.086 2.582-4.292 1.37c-.243 1.47-.266 2.818.359 3.17 1.525.861 4.048 2.584 4.048 2.584l-1.207 9.087-7.186 2.8c2.128 4.923 19.612 13.227 25.542.152l-5.929-2.6",
    fill: "#fd9f9d"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M748.56 461.854s3.933-4.268 9.247-1.917 6.288 7.678 4.327 14.368-1.179 20.219-1.179 20.219l-12.825-3.567-.919-18.633 1.349-10.47",
    fill: "#ff516c"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M737.999 485.896s-3.384-3.44-2.034-6.9c0 0 5.509-1.559 3.9-4.623s-5.482 1.389-5.482 1.389-.544-5.867-1.86-7.8c-3.552-5.2-3.516-9.283 1.511-10.57s18.339-.701 18.731 10.923-12.592 13.9-14.766 17.581",
    fill: "#ff7381"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M727.809 470.772a1.182 1.182 0 11.977 1.356 1.182 1.182 0 01-.977-1.356M731.188 468.759a.389.389 0 00.343-.654 3.167 3.167 0 00-3.666-.6.39.39 0 00.358.691 2.4 2.4 0 012.747.451.385.385 0 00.218.114",
    fill: "#131412"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M735.12 477.663a.257.257 0 00.179-.036l3.433-2.151a.26.26 0 00-.276-.44l-3.432 2.152a.259.259 0 00.1.476M737.696 494.525v4.116l1.942-3.261-1.942-.85",
    fill: "#ff7381"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M775.466 557.457l10.817-27.535a1.185 1.185 0 011.235-.744l13.783 1.538a1.14 1.14 0 01.921 1.585l-9.885 25.82-16.871-.665",
    fill: "#131412"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#a7deff"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M768.81 515.562l9.068 9.176-.865.855-9.068-9.174.865-.857M775.99 503.052l6.357 10.149-1.031.646-6.357-10.149 1.031-.646M793.725 501.332l1.882 11.241-1.2.2-1.882-11.241 1.2-.2"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M720.833 544.309q-9.74 5.867-18.8 12.412c.548 1.4 1.19 2.981 1.91 4.688 6.537-3.628 12.579-8 18.805-12.151l-1.915-4.95",
    fill: "#fffffe"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M775.104 552.807l-40.2 27.867-12.156-31.415c-6.226 4.145-12.268 8.522-18.808 12.153 4.424 10.481 11.935 25.744 20.578 32.709 13.836 11.15 52.857-35.069 52.857-35.069l7.3-.406 2.465-5.64-12.036-.2",
    fill: "#fd9f9d"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M734.902 580.674l2.338 4.931v-6.552l-2.338 1.621",
    fill: "#ff7381"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M799.201 534.999a1.594 1.594 0 10-2.1.831 1.594 1.594 0 002.1-.831",
    fill: "#fffffe"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M757.418 611.372l-64.041 15.074-2.163-5.758 66.2-9.319",
    fill: "#009b56"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M743.626 497.121l3.749 35.651c4.92-2.08 9.82-4.208 14.737-6.323-3.466-23.116-14.753-27.674-18.486-29.328",
    fill: "#fff03d"
  })))));
}
export default SvgInvite;